import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useWhoami } from "@/api/auth";

export function useAuthGuard() {
  const { data, isLoading } = useWhoami();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading) return;
    if (data && data.auth_required && !data.authenticated) {
      navigate(`/login?next=${encodeURIComponent(location.pathname)}`, { replace: true });
    }
  }, [data, isLoading, navigate, location.pathname]);

  return { data, isLoading };
}
